export const ACCOUNT_SETUP_GET_STUDENTS = 'ACCOUNT_SETUP_GET_STUDENTS';
export const ACCOUNT_SETUP_GET_STUDENTS_ERROR =
  'ACCOUNT_SETUP_GET_STUDENTS_ERROR';
export const ACCOUNT_SETUP_GRID_LOADING = 'ACCOUNT_SETUP_GRID_LOADING';
export const ACCOUNT_SETUP_GET_ALLERGENS_ERROR =
  'ACCOUNT_SETUP_GET_ALLERGENS_ERROR';
export const ACCOUNT_SETUP_GET_ALLERGENS = 'ACCOUNT_SETUP_GET_ALLERGENS';
export const ACCOUNT_SETUP_ALLERGEN_DATA_CHECK =
  'ACCOUNT_SETUP_ALLERGEN_DATA_CHECK';
export const ACCOUNT_SETUP_ALLERGEN_CHECKALL =
  'ACCOUNT_SETUP_ALLERGEN_CHECKALL';

export const ACCOUNT_SETUP_POST_ALLERGENS = 'ACCOUNT_SETUP_POST_ALLERGENS';
export const ACCOUNT_SETUP_POST_ALLERGENS_ERROR =
  'ACCOUNT_SETUP_POST_ALLERGENS_ERROR';
export const ACCOUNT_SETUP_GET_STUDENTINFO = 'ACCOUNT_SETUP_GET_STUDENTINFO';
export const ACCOUNT_SETUP_GET_STUDENTINFO_ERROR =
  'ACCOUNT_SETUP_GET_STUDENTINFO_ERROR';
export const ACCOUNT_SETUP_UPDATE_STUDENTINFO =
  'ACCOUNT_SETUP_UPDATE_STUDENTINFO';
export const ACCOUNT_SETUP_SAVE_STUDENTINFO = 'ACCOUNT_SETUP_SAVE_STUDENTINFO';
export const ACCOUNT_SETUP_SAVE_STUDENTINFO_ERROR =
  'ACCOUNT_SETUP_SAVE_STUDENTINFO_ERROR';
export const ACCOUNT_SETUP_STUDENTINFO_LOADING =
  'ACCOUNT_SETUP_STUDENTINFO_LOADING';
export const ACCOUNT_SETUP_STUDENT_FILTER = 'ACCOUNT_SETUP_STUDENT_FILTER';

export const ACCOUNT_SETUP_NEW_STUDENT = 'ACCOUNT_SETUP_NEW_STUDENT';
export const ACCOUNT_SETUP_NEW_STUDENT_ERROR =
  'ACCOUNT_SETUP_NEW_STUDENT_ERROR';
export const ACCOUNT_SETUP_GET_SERVINGNUMBER =
  'ACCOUNT_SETUP_GET_SERVINGNUMBER';
export const ACCOUNT_SETUP_GET_SERVINGNUMBER_ERROR =
  'ACCOUNT_SETUP_GET_SERVINGNUMBER_ERROR';
export const ACCOUNT_SETUP_CLEAR_SERVINGNUMBER =
  'ACCOUNT_SETUP_CLEAR_SERVINGNUMBER';
export const ACCOUNT_SETUP_GET_PROHIBITED_ITEMS =
  'ACCOUNT_SETUP_GET_PROHIBITED_ITEMS';
export const ACCOUNT_SETUP_PROHIBITED_ITEMS_LOADING =
  'ACCOUNT_SETUP_PROHIBITED_ITEMS_LOADING';
export const ACCOUNT_SETUP_UPDATE_PROHIBITED_ITEM =
  'ACCOUNT_SETUP_UPDATE_PROHIBITED_ITEM';
export const ACCOUNT_SETUP_CHECK_ALL_PROHIBITED_ITEMS =
  'ACCOUNT_SETUP_CHECK_ALL_PROHIBITED_ITEMS';
export const ACCOUNT_SETUP_PROHIBITED_ITEMS_SAVING =
  'ACCOUNT_SETUP_PROHIBITED_ITEMS_SAVING';
export const ACCOUNT_SETUP_PROHIBITED_ITEMS_SAVE_ERROR =
  'ACCOUNT_SETUP_PROHIBITED_ITEMS_SAVE_ERROR';
export const ACCOUNT_SETUP_PROHIBITED_ITEMS_CLEAR_ERROR =
  'ACCOUNT_SETUP_PROHIBITED_ITEMS_CLEAR_ERROR';
export const ACCOUNT_SETUP_PROHIBITED_ITEMS_SAVE_SUCCESS =
  'ACCOUNT_SETUP_PROHIBITED_ITEMS_SAVE_SUCCESS';
export const ACCOUNT_SETUP_PROHIBITED_ITEMS_RESET =
  'ACCOUNT_SETUP_PROHIBITED_ITEMS_RESET';
export const ACCOUNT_SETUP_STUDENT_SAVING = 'ACCOUNT_SETUP_STUDENT_SAVING';
export const ACCOUNT_SETUP_VALID_STATUS_LOADING =
  'ACCOUNT_SETUP_VALID_STATUS_LOADING';
export const ACCOUNT_SETUP_GET_VALID_STATUS = 'ACCOUNT_SETUP_GET_VALID_STATUS';
export const ACCOUNT_SETUP_SET_VALIDSTATUSFIELDCHANGED =
  'ACCOUNT_SETUP_SET_VALIDSTATUSFIELDCHANGED';
export const ACCOUNT_SETUP_SET_IS_NEW_STUDENT =
  'ACCOUNT_SETUP_SET_IS_NEW_STUDENT';
export const ACCOUNT_SETUP_SET_SHOW_EDIT_MODAL =
  'ACCOUNT_SETUP_SET_SHOW_EDIT_MODAL';

export const ACCOUNT_SETUP_ROWINDEX = 'ACCOUNT_SETUP_ROWINDEX';

export const ACCOUNT_SETUP_POST_STUDENTNUMBER =
  'ACCOUNT_SETUP_POST_STUDENTNUMBER';
export const ACCOUNT_SETUP_POST_STUDENTNUMBER_ERROR =
  'ACCOUNT_SETUP_POST_STUDENTNUMBER_ERROR';
export const ACCOUNT_SETUP_CLEAR_CHANGE_STUDENT_NUMBER =
  'ACCOUNT_SETUP_CLEAR_CHANGE_STUDENT_NUMBER';
export const ACCOUNT_SETUP_CHANGE_STUDENT_NUMBER_LOADING =
  'ACCOUNT_SETUP_CHANGE_STUDENT_NUMBER_LOADING';

export const ACCOUNT_SETUP_DELETE_STUDENT = 'ACCOUNT_SETUP_DELETE_STUDENT';
export const ACCOUNT_SETUP_DELETE_STUDENT_ERROR =
  'ACCOUNT_SETUP_DELETE_STUDENT_ERROR';

export const ACCOUNT_SETUP_GET_TRANSACTIONHISTORY =
  'ACCOUNT_SETUP_GET_TRANSACTIONHISTORY';
export const ACCOUNT_SETUP_GET_TRANSACTIONHISTORY_ERROR =
  'ACCOUNT_SETUP_GET_TRANSACTIONHISTORY_ERROR';

export const ACCOUNT_SETUP_CLEAR_MEALHISTORY =
  'ACCOUNT_SETUP_CLEAR_MEALHISTORY';
export const ACCOUNT_SETUP_MEALHISTORY_LOADING =
  'ACCOUNT_SETUP_MEALHISTORY_LOADING';
export const ACCOUNT_SETUP_SET_SELECTED_TAB = 'ACCOUNT_SETUP_SET_SELECTED_TAB';
export const ACCOUNT_SETUP_CLEAR_STUDENTINFO =
  'ACCOUNT_SETUP_CLEAR_STUDENTINFO';
export const ACCOUNT_SETUP_STUDENTINFO_FILTER =
  'ACCOUNT_SETUP_STUDENTINFO_FILTER';

export const ACCOUNT_SETUP_GET_BILLING_ACCOUNT_STUDENTS = 'ACCOUNT_SETUP_GET_BILLING_ACCOUNT_STUDENTS';
export const ACCOUNT_SETUP_CLEAR_BILLING_ACCOUNT_STUDENTS = 'ACCOUNT_SETUP_CLEAR_BILLING_ACCOUNT_STUDENTS';
export const ACCOUNT_SETUP_GET_BILLING_ACCOUNT_STUDENTS_ERROR = 'ACCOUNT_SETUP_GET_BILLING_ACCOUNT_STUDENTS_ERROR';



// WEBPACK FOOTER //
// ./src/pages/accountsetup/state/types.js